import { Component, OnInit, inject } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { HeadService } from '../../services/head.service';
import { TitleService } from '../../services/title.service';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    imports: [BreadCrumbComponent]
})
export class TermsComponent implements OnInit {
  private breadcrumbService = inject(BreadcrumbService);
  private headService = inject(HeadService);
  private titleService = inject(TitleService);


  ngOnInit(): void {
    const title = 'Terms';
    this.titleService.set(title);
    this.breadcrumbService.set(title);
    this.headService.setMetaDescription(title);
  }
}
